module.exports = __webpack_public_path__ + "img/app1.8b06c816.png";